import { buildNewsCriteria, type NewsCriteriaInput } from "./criteria-builder";
import { type ConfigItem, FactSetWidget } from "./FactsetWidget";

export type NewsItemClickEvent = {
  detail: [
    {
      identifier: string;
    },
  ];
};

type NewsListProps = {
  onNewsClick: (event: NewsItemClickEvent) => void;
  criteria?: NewsCriteriaInput;
};

export function NewsList({ onNewsClick, criteria }: NewsListProps) {
  const config: ConfigItem[] = [
    { type: "event", key: "row-click", value: onNewsClick },
  ];

  if (criteria) {
    config.push({
      type: "attribute",
      key: "criteria",
      value: buildNewsCriteria(criteria),
    });
  }

  return <FactSetWidget config={config} widget="news-list" />;
}
